import {Box, CircularProgress, Typography} from '@mui/material';

const QuizHeader = ({ 
  title, 
  currentQuestion, 
  totalQuestions, 
  timeLeft 
}) => {
  const getTimerColor = () => {
    if (timeLeft > 30) return '#4caf50';
    if (timeLeft > 10) return '#ff9800';
    return '#f44336';
  };

  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      <Typography 
        variant="h6"
        sx={{
          fontWeight: 'bold',
          background: 'linear-gradient(45deg, var(--color-secondary) 0%, var(--color-secondary-light) 100%)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          textShadow: '0 2px 4px rgba(0,0,0,0.2)'
        }}
      >
        {title} - Frage {currentQuestion} von {totalQuestions}
      </Typography>
      <Box sx={{ position: 'relative', display: 'inline-flex' }}>
        <CircularProgress
          variant="determinate"
          value={(timeLeft / 60) * 100}
          size={60}
          thickness={5}
          sx={{
            color: getTimerColor(),
            transition: 'all 0.3s ease',
            '& .MuiCircularProgress-circle': {
              strokeLinecap: 'round',
              filter: 'drop-shadow(0 0 2px rgba(0,0,0,0.3))'
            }
          }}
        />
        <Box
          sx={{
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            position: 'absolute',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Typography 
            variant="caption" 
            component="div" 
            sx={{ 
              color: 'var(--color-text-primary)',
              fontWeight: 'bold',
              fontSize: '1rem',
              textShadow: '0 1px 2px rgba(0,0,0,0.3)'
            }}
          >
            {timeLeft}s
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default QuizHeader; 